import script from "./EditBalise.vue?vue&type=script&setup=true&lang=js"
export * from "./EditBalise.vue?vue&type=script&setup=true&lang=js"

import "./EditBalise.vue?vue&type=style&index=0&id=3d0843dd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d0843dd"]])

export default __exports__